module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/rc-switch/es/index.js
// module id = 367
// module chunks = 0